import { types } from './actions';

const initialState = {
  isOpen: false,
  isSaving: false,
  material: null,
  supplierMaterial: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.MATERIAL_MODAL_OPEN:
      return {
        ...state,
        isOpen: true,
        material: action.payload.material,
        supplierMaterial: action.payload.supplierMaterial,
      };
    case types.MATERIAL_MODAL_CLOSE:
      return {
        ...state,
        isOpen: false,
      };
    case types.MATERIAL_MODAL_SAVE_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    case types.MATERIAL_MODAL_SAVE_SUCCESS:
      return {
        ...state,
        isOpen: false,
        isSaving: false,
      };
    case types.MATERIAL_MODAL_SAVE_ERROR:
      return {
        ...state,
        isSaving: false,
      };
    default:
      return state;
  }
};

export const getScope = (state) =>
  state.modules.common.modals.supplierMaterialModal;

export const getMaterial = (state) => getScope(state).material;

export const getSupplierMaterial = (state) => getScope(state).supplierMaterial;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getIsSaving = (state) => getScope(state).isSaving;
